import React, { PropsWithChildren } from "react";
import { ContentWrapper, AppBarSpacer, ContainerStyles } from "./BodyContent.styles";
import { Box } from "@mui/material";
import { Copyright } from "../../atoms/Copyright";

export default function BodyContent({ children }: PropsWithChildren<{}>) {
  return (
    <ContentWrapper>
      <AppBarSpacer />
      <ContainerStyles maxWidth={false}>{children}</ContainerStyles>
      <Box pt={4} style={{ textAlign: "center", position: "relative", bottom: 0 }}>
        <Copyright />
      </Box>
    </ContentWrapper>
  );
}
